import { IAxiosError } from '@shared/types/AxiosError';
import { useQuery } from '@tanstack/react-query';

import { IGetRequestAllInfo, getRequestAllInfo } from '../services';

export function useGetRequestAllInfo() {
  const { data, isLoading, isFetching, error, ...query } = useQuery(
    ['getRequestAllInfo'],
    () => getRequestAllInfo(),
  );

  return {
    data: data?.data || ({} as IGetRequestAllInfo),
    isFindingAllInfo: isLoading || isFetching,
    errorFindingAllInfo: error as IAxiosError,
    ...query,
  };
}
export const QUERY_KEY_GET_REQUEST_ALL_INFO = ['getRequestAllInfo'];
